import styled from '@emotion/styled';
import { lpPageColors, mainColors } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';

import { RemoveTrashIcon } from 'src/assets/icons/RemoveTrashIcon';

interface HomePageCarouselItemType {
    imgSrc: string;
    isStart?: boolean;
    homepage?: boolean;
}

export const TrashIconWrapper = styled(RemoveTrashIcon, { label: 'TrashIconWrapper' })`
    align-self: center;
    cursor: pointer;
    margin-left: 8px;
`;

export const ActiveLabel = styled('span', { label: 'ActiveLabel' })`
    color: ${lpPageColors.activeLabel};
    font-size: 12px;
    font-weight: ${fontWeight.bold};
    line-height: 1.3334;
    margin-left: 12px;
`;

export const DatesContainer = styled('div', { label: 'DatesContainer' })`
    display: flex;
`;

type DateWrapperType = Pick<HomePageCarouselItemType, 'isStart'>;

export const DateWrapper = styled('div', { label: 'DateWrapper' })<DateWrapperType>`
    ${({ isStart }): string => isStart === true ? 'margin-right: 16px;' : ''};
    display: flex;
    flex-direction: column;
`;

export const DateTitle = styled('div', { label: 'DateTitle' })`
    color: ${mainColors.grays.gray400};
    font-size: ${fontSize.small};
    line-height: 1.33;
`;

export const DateValue = styled('div', { label: 'DateValue' })`
    font-size: ${fontSize.xRegular};
    line-height: 1.2;
`;
